import { render, staticRenderFns } from "./AdvAbility.vue?vue&type=template&id=12dfc7d2&scoped=true&"
import script from "./AdvAbility.vue?vue&type=script&lang=ts&"
export * from "./AdvAbility.vue?vue&type=script&lang=ts&"
import style0 from "./AdvAbility.vue?vue&type=style&index=0&id=12dfc7d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12dfc7d2",
  null
  
)

export default component.exports